import React, { useContext } from 'react';
import { GlobeIcon } from 'lucide-react';
import { LanguageContext } from '../App';
import { Tooltip } from './ui/Tooltip';
export const LanguageSwitcher: React.FC = () => {
  const {
    language,
    setLanguage
  } = useContext(LanguageContext);
  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'ar' : 'en');
  };
  return <Tooltip content={language === 'en' ? 'Switch to Arabic' : 'التبديل إلى الإنجليزية'} side="bottom" data-id="element-636">
      <button onClick={toggleLanguage} className="flex items-center px-2 md:px-3 py-1 md:py-2 text-sm font-medium text-gray-700 rounded-md hover:bg-gray-100" data-id="element-637">
        <GlobeIcon size={18} className="mr-1 md:mr-2" data-id="element-638" />
        <span className="hidden md:inline" data-id="element-639">
          {language === 'en' ? 'العربية' : 'English'}
        </span>
        <span className="md:hidden" data-id="element-640">{language === 'en' ? 'AR' : 'EN'}</span>
      </button>
    </Tooltip>;
};